import React, {useState, forwardRef} from 'react'
import Modal from 'react-modal'

import Envelope from '../../assets/img/envelope.svg'
import {_validateMail} from '../../Utils/tools'
import loadingYapp from '../../assets/img/yapp_loading.gif'
import Input from '../Forms/Input'

const ModalSendPrices = forwardRef((props) => {
  const {modalSendPricesState, setModalSendPricesState} = props
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [isValid, setIsValid] = useState(false)

  function closeModalSend() {
    setLoading(false)
    setModalSendPricesState(false)
  }

  function onChangeEmail(email) {
    setEmail(email)
    if (_validateMail(email)) setIsValid(email)
  }

  return (
    <Modal
      isOpen={modalSendPricesState}
      onAfterOpen={null}
      onRequestClose={closeModalSend}
      className="modal-custom"
      overlayClassName="modal-custom-bg"
      contentLabel="ModalTypeFormsHome"
      ariaHideApp={false}>
      <div>
        <button className="btn-circle-close" onClick={() => closeModalSend()}>
          <i className="icon-close"></i>
        </button>
        {loading ? (
          <div className="w-100 d-flex flex-column justify-content-center align-items-center mt-3 mb-4">
            <img
              src={loadingYapp}
              alt="loading"
              className="loading-yapp--normal m-0"
            />
          </div>
        ) : (
          <div>
            <div className="w-100 d-flex flex-column justify-content-center align-items-center w-100 mt-3">
              <h2 className="txt-3--bold mb-2">
                Comparte Yapp con tu paciente
              </h2>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <img
                  src={Envelope}
                  style={{width: '10.9375rem', height: '2.4375rem'}}
                  alt="envelope"
                />
              </div>

              <div className="mb-2 w-100 mt-3 mb-4">
                <Input
                  id="gtm-webapp-validation-email-input"
                  error={
                    email.length > 0 &&
                    !isValid && {message: '*Correo inválido'}
                  }
                  label="Correo electrónico"
                  placeholder="Correo electrónico"
                  doChange={(value) => onChangeEmail(value)}
                />
              </div>
            </div>
            <button
              id={'gtm-webapp-validation-email-btn'}
              className="btn-default--small font--14 btn-next mx-auto"
              onClick={() => props.onClickButton(email)}>
              Enviar
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
})
export default ModalSendPrices
